import { pb } from "./pocketbase";

export interface AccessUser { id: string; email: string; name: string }
export interface WorkspaceAccess {
  user: AccessUser;
  workspace_id: string;
  membership: { id: string; role_id: string; role_key: string; role_name: string } | null;
  role_permissions: string[];
  effective_permissions: string[];
  revision: string;
  access_revision: number;
  upload: { account_enabled: boolean; account_workspace_id: string; grant_id: string | null;
    grant_active: boolean; attribution: string | null; authorized: boolean;
    context: { ready: boolean; reason: string | null } };
}
export interface AccessHistory {
  id: string; created: string; actor: string; action: string;
  metadata: { capability: string; role_action: string };
}
export function workspaceAccessRequest<T>(action: string, body: object, signal?: AbortSignal): Promise<T> {
  return pb.send(`/api/neoma/workspace-access/${action}`, { method: "POST", body, signal });
}
